import { render, staticRenderFns } from "./CandidateSendCertificate.vue?vue&type=template&id=2a8a2bd6&lang=pug&"
import script from "./CandidateSendCertificate.vue?vue&type=script&lang=js&"
export * from "./CandidateSendCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSendCertificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VSpacer,VTextField})
